import React from "react";
import { Navigate } from "react-router-dom";

// Widgets
import Widgets from "../pages/Dashboard/Index";

//AuthenticationInner pages
import Basic404 from "../pages/Authentication/Basic404.js";
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import ResetPasswordForm from "../pages/Authentication/ResetPassword.js";

// User
import UsersList from "../pages/Users/users.js";
import UserProfile from "../pages/Authentication/userProfile.js";

//Component
import NameComponent from "../pages/Components/NameComponent.js";
import EmailComponent from "../pages/Components/EmailComponent.js";
import AmountComponent from "../pages/Components/AmountComponent.js";
import PasswordComponent from "../pages/Components/PasswordComponent.js";
import AlphaNumericComponent from "../pages/Components/AlphaNumericComponent.js";
import PhoneNumberComponent from "../pages/Components/PhoneNumberComponent.js";
import DropdownComponent from "../pages/Components/DropdownComponent.js";
import MultiSelectDropdownComponent from "../pages/Components/MultiSelectDropdownComponent.js";
import SingleCheckboxComponent from "../pages/Components/SingleCheckboxComponent.js";
import MultiCheckboxGroupComponent from "../pages/Components/MultiCheckboxGroupComponent.js";
import RadioGroupComponent from "../pages/Components/RadioGroupComponent.js";
import FileUploadInputComponent from "../pages/Components/FileUploadInputComponent.js";
import DatePickerComponent from "../pages/Components/DatePickerComponent.js";
import WeightInputComponent from "../pages/Components/WeightInputComponent.js";
import TextareaInputComponent from "../pages/Components/TextareaInputComponent.js";
import WYSIWYGEditorComponent from "../pages/Components/WYSIWYGEditorComponent.js";
import SwitchInputComponent from "../pages/Components/SwitchInputComponent.js";
import RangePickerInputComponent from "../pages/Components/RangePickerInputComponent.js";
import DimensionComponent from "../pages/Components/DimensionComponent.js";
import UpdateForm from "../pages/Components/UpdateForm.js";
import AddForm from "../pages/Components/AddForm.js";
import UrlComponent from "../pages/Components/UrlComponent.js";


const authProtectedRoutes = [

  // Dashboard
  { path: "/dashboard", component: <Widgets /> },
  // Other pages
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/404" /> },

  // Profile
  { path: "/profile", component: <UserProfile /> },

  //users
  { path: "/user", component: <UsersList /> },

  //Components
  { path: "/components/name", component: <NameComponent /> },
  { path: "/components/email", component: <EmailComponent /> },
  { path: "/components/amount", component: <AmountComponent /> },
  { path: "/components/password", component: <PasswordComponent /> },
  { path: "/components/string", component: <AlphaNumericComponent /> },
  { path: "/components/phone", component: <PhoneNumberComponent /> },
  { path: "/components/dropdown", component: <DropdownComponent /> },
  { path: "/components/multi-select-dropdown", component: <MultiSelectDropdownComponent /> },
  { path: "/components/checkbox", component: <SingleCheckboxComponent /> },
  { path: "/components/multi-checkbox", component: <MultiCheckboxGroupComponent /> },
  { path: "/components/radio", component: <RadioGroupComponent /> },
  { path: "/components/file-upload", component: <FileUploadInputComponent /> },
  { path: "/components/date-picker", component: <DatePickerComponent /> },
  { path: "/components/weight", component: <WeightInputComponent /> },
  { path: "/components/textarea", component: <TextareaInputComponent /> },
  { path: "/components/WYSIWYG-editor", component: <WYSIWYGEditorComponent /> },
  { path: "/components/switch", component: <SwitchInputComponent /> },
  { path: "/components/range", component: <RangePickerInputComponent /> },
  { path: "/components/dimension", component: <DimensionComponent /> },
  { path: "/components/url", component: <UrlComponent /> },
  { path: "/components/form", component: <AddForm /> },
  { path: "/components/update-form", component: <UpdateForm /> },

];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPasswordForm /> },
  { path: "/404", component: <Basic404 /> },
];

export { authProtectedRoutes, publicRoutes };
